"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    deletingTrailError: {
        en: "unable to delete trail",
        es: "No se puede eliminar el rastro.",
    },
    searchTrail: {
        en: "Search Trail",
        es: "Buscar Rastro",
    },
    addTrail: {
        en: "Add Trail",
        es: "Agregar Rastro",
    },
    editTrail: {
        en: "Edit Trail",
        es: "Editar Rastro",
    },
    deleteTrail: {
        en: "Delete Trail",
        es: "Eliminar Rastro",
    },
    drawATrail: {
        en: "You need to create a trail!",
        es: "Necesitas crear un rastro!",
    },
    saveTrailSuccess: {
        en: "The trail was save successfully.",
        es: "El rastro se guardo exitosamente.",
    },
    initialPoint: {
        en: "Initial Point",
        es: "Punto Inicial",
    },
    initialPointRequiredMessage: {
        en: "The starting point is required!",
        es: "El punto inicial es requerido!",
    },
    initialPointPlaceholder: {
        en: "Choose the point where the route starts",
        es: "Selecciona el punto donde inicia la ruta",
    },
    finalPoint: {
        en: "Final Point",
        es: "Punto Final",
    },
    finalPointRequiredMessage: {
        en: "The final point is required!",
        es: "El punto final es requerido!",
    },
    finalPointPlaceholder: {
        en: "Choose the point where the route ends",
        es: "Selecciona el punto donde termina la ruta",
    },
    timeTransit: {
        en: "Transit Time",
        es: "Tiempo en Tránsito",
    },
    timeTransitRequiredMessage: {
        en: "Time in transit is required!",
        es: "El tiempo en tránsito es requerido!",
    },
    timeClient: {
        en: "Time in Client",
        es: "Tiempo en Cliente",
    },
    timeClientRequiredMessage: {
        en: "The time in client is required!",
        es: "El tiempo en cliente es requerido!",
    },
    confirmDeleteTrail: {
        en: "Do you want to delete this trail?",
        es: "Deseas eliminar este rastro?",
    },
};
exports.default = translations;
